// extracted by mini-css-extract-plugin
module.exports = {"container":"vX3+B","header":"YFhEu","inner":"daqj1","extra":"_06DLu","apps":"g0a9e","app":"ZQKSq","icon":"_0Rm1C","label":"yhHr6"};